import AgyleDialog from "../../../components/modal/agyleDialog";
import * as React from "react";
import Hl7utils from "./hl7utils";
import useOpenState from "../../../hooks/useOpenState";

function Hl7ViewJson (props) {

    const hl7JsonMessage = () => {
        let hl7obj1 =  Hl7utils.parseHl7ToJson(props.message);
        let hl7obj2 = {};
        for (let o1 of hl7obj1) {
            let segment = o1[0];
            hl7obj2[segment] = {};
            for (let i = 1; i < o1.length; i++) {
                hl7obj2[segment][`${segment}.${i}`] = o1[i];
            }
        }
        return JSON.stringify(hl7obj2, null, 2)

    }

    return (  <AgyleDialog
        title={"Hl7 Message as JSON"}
        open={props.isOpen}
        onClose={props.handleCloseModal}
        width={"lg"}
        fullWidth
        disableSave
    >
        <pre> {hl7JsonMessage()} </pre>
    </AgyleDialog>)
}

export default Hl7ViewJson